import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import { lazyRetry } from '@utils/lazyRetry';
import LegacyCaptureRedirect from '../capture/LegacyCaptureRedirect';

// All documentation pages are lazy. Route files are eagerly globbed in routesConfig,
// so static imports here would pull every guide page into the app entry chunk that
// loads on every page.
const HelpCenterApp = lazyRetry(() => import('./HelpCenterApp'));
const HelpCenterHome = lazyRetry(() => import('./home/HelpCenterHome'));
const FAQsPage = lazyRetry(() => import('./home/FAQsPage'));
const CaptureFAQsPage = lazyRetry(() => import('./home/CaptureFAQsPage'));
const GuidesPage = lazyRetry(() => import('./home/GuidesPage'));
const BatchWorkflowGuide = lazyRetry(() => import('./guides/BatchWorkflowGuide'));
const ScannerSetupGuide = lazyRetry(() => import('./guides/ScannerSetupGuide'));
const AnnotationToolsGuide = lazyRetry(() => import('./guides/AnnotationToolsGuide'));
const ArchiveManagementGuide = lazyRetry(() => import('./guides/ArchiveManagementGuide'));

/**
 * The Help Center App Route.
 */
const HelpCenterAppRoute: FuseRouteItemType = {
    path: 'documentation',
    element: <HelpCenterApp />,
    children: [
        {
            path: '',
            element: <HelpCenterHome />
        },
        {
            path: 'faqs',
            element: <FAQsPage />
        },
        {
            path: 'connect-faqs',
            element: <CaptureFAQsPage />
        },
        {
            path: 'capture-faqs',
            element: <LegacyCaptureRedirect />
        },
        {
            path: 'dispatch-faqs',
            element: <LegacyCaptureRedirect />
        },
        {
            path: 'guides',
            element: <GuidesPage />
        },
        {
            path: 'guides/batch-workflow',
            element: <BatchWorkflowGuide />
        },
        {
            path: 'guides/scanner-setup',
            element: <ScannerSetupGuide />
        },
        {
            path: 'guides/annotation-tools',
            element: <AnnotationToolsGuide />
        },
        {
            path: 'guides/archive-management',
            element: <ArchiveManagementGuide />
        }
    ]
};

export default HelpCenterAppRoute;
